"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var tokens = {
  borderRadius: 4,
  defaultMargin: 0,
  spacingUnit: 1,
  spacingUnitHalf: 0.5
};
var _default = tokens;
exports["default"] = _default;